export default {
    InternalRefundOnly: {
        Doc: '退款单号/销售单号',
        DocType: '退款单类型',
        Source: '退款单来源',
        nickname: '买家昵称',
        Three: '三方退款时间',
        Add: '新增仅退款单',
        form: {
            NoteNo: '内部退款单号',
            refundorder: '三方退款单号',
            partyorder: '客户订单号',
            Internalorder: '内部订单号',
            Refundtype: '退款单类型',
            type: '退款类型',
            Note: '退款单来源',
            reason: '退款原因',
            Buyer: '买家备注',
            Customer: '客服备注',
            quantity: '退款数量',
            Total: '合计退款金额',
            method: '结算方式',
            nickname: '买家昵称',
            Sales: '销售店铺',
            channel: '销售渠道',
            Three: '三方退款时间',
            Internal: '内部创单时间',
            Refund: '退款完成时间',
        },

    }
};
